import styled from 'shared/utils/styled';

export const LedgerAccountEventsList = styled('ul')(() => ({
  margin: 0,
  padding: 0,
  listStyle: 'none',
}));
